<script>
    // @ts-nocheck

    import LocationPicker from '$lib/components/UI/LocationPicker.svelte'
    import {
        FormBox,
        Chip,
        Banner,
        Breadcrumb,
        Button,
        ModalX,
        BackDrop,
        Typography,
    } from '$lib/components/UI'
    import { onMount } from 'svelte'
    import user from '$lib/stores/user'
    import ShowEye from '$lib/components/Icons/custom/ShowEye.svelte'
    import { fade } from 'svelte/transition'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import Content from '$lib/components/layout/Content.svelte'
    import LicitacionWidget from '$lib/custom/components/LicitacionWidget2.svelte'
    import { now } from '$lib/stores/device'
    import licitaciones from '$lib/services/collections/tenders'
    import { timeParse, getDiffDate, getDateObj } from '$lib/utils'
    import { writable } from 'svelte/store'
    import dictionaries from '$lib/stores/dictionaries'
    import Gallery from '$lib/components/UI/Gallery.svelte'

    export let data = {}
    export let ofertable = true
    export let visible = false

    let autoSync = setInterval(async () => {
        let key = [data.id_licitacion, user.currentAccount]
        if (key.every((x) => x)) {
            data = await licitaciones.get(key).catch((r) => {
                return data
            })
        }
    }, 30000)
    onMount(() => {
        return () => {
            //onDestroy
            clearInterval(autoSync)
        }
    })
    $: ubic = data?.ubicacion
        ?.split(', ')
        ?.map((x, i) => [['lat', 'lng'][i], parseFloat(x)])
        ?.reduce((r, [k, v]) => ({ ...r, [k]: v }), {}) || { lat: 0, lng: 0 }
    const schema = {
        categoria: {
            label: 'Categoría',
            render: (v) =>
                $dictionaries?.lic_items_polaris?.find((t) => t.value === v)
                    ?.label || '-',
        },
        producto: {
            render: (v) =>
                $dictionaries?.lic_items_polaris.find((i) => i.value === v)
                    ?.label,
        },
        descripcion: { label: 'Descripción' },
        cantidad: {},
    }

    const dataItems = writable(
        data?.items?.map((x, index) => ({ ...x, id: index })) || []
    )
    let sites = [
        { label: 'Licitaciones', path: '/home/licitaciones' },
        { label: data.id, path: `/home/licitaciones/${data.id_licitacion}` },
    ]
    let date_licitacion = getDateObj(data?.fecha_vencimiento,-3)
    $: timeAvailable = getDiffDate(date_licitacion, $now)
    $: state = timeAvailable > 0 ? data.state : 'Finalizada'
    $: photos = data?.gallery || []
</script>

<!-- <Breadcrumb options={sites} limit={0}/> -->
<Banner
    label="LICITACIÓN"
    title={`Licitacion ${data.id_licitacion}`}
    --chip-color={state == 'Abierta' ? '#00669E' : 'rgba(0, 0, 0, 0.30)'}
    {state}
/>
<!-- info={[
        // {label: 'Estado', value: 'Adjudicada'},
        // {label: 'Fecha de inicio', value: data?.fecha_licitacion},
        // {label: 'Fecha de vencimiento', value: data?.fecha_vencimiento},
        // {label: 'Finaliza en', value: timeParse(timeAvailable, '%H:%M:%s')}
    ]} -->
<Content
    style="display: flex; flex-direction: column;gap: 35px; width: 100%; padding: 25px 68px 68px 68px"
>
    <!-- <FormBox.Container title="Datos del Asegurado">
        <FormBox.Row >
            <FormBox.Cell label="Nombre completo" value={data?.nombre_apellido_asegurado}></FormBox.Cell>            
            <FormBox.Cell label="DNI" value={data?.dni_asegurado}></FormBox.Cell>            
        </FormBox.Row>
    </FormBox.Container> -->

    <FormBox.Container title="Datos del vehiculo">
        <FormBox.Row>
            <FormBox.Cell label="Patente" value={data?.patente_vehiculo}
            ></FormBox.Cell>
            <FormBox.Cell label="Año" value={data?.anio_vehiculo}
            ></FormBox.Cell>
        </FormBox.Row>
        <FormBox.Row>
            <FormBox.Cell label="Motor" value={data?.motor_vehiculo}
            ></FormBox.Cell>
            <FormBox.Cell label="Número de chasis" value={data?.numero_chasis}
            ></FormBox.Cell>
        </FormBox.Row>
        <FormBox.Row>
            <FormBox.Cell label="Código Infoauto" value={data?.codigo_infoauto}
            ></FormBox.Cell>
            <FormBox.Cell label="Marca" value={data?.marca_vehiculo}
            ></FormBox.Cell>
            <FormBox.Cell label="Modelo" value={data?.modelo_vehiculo}
            ></FormBox.Cell>
        </FormBox.Row>
    </FormBox.Container>

    <FormBox.Container title="Siniestro">
        <FormBox.Row>
            <FormBox.Cell label="Número de siniestro" value={data?.id_siniestro}
            ></FormBox.Cell>
            <FormBox.Cell label="Código postal" value={data?.cp}></FormBox.Cell>
            <FormBox.Cell label="Alcance" value={`${data?.alcance} Km`}
            ></FormBox.Cell>
        </FormBox.Row>
    </FormBox.Container>

    <FormBox.Container title="Dirección">
        <FormBox.Row>
            <FormBox.Cell label="Localidad" value={data?.localidad}
            ></FormBox.Cell>
            <FormBox.Cell label="Calle" value={data?.calle}></FormBox.Cell>
            <FormBox.Cell label="Altura" value={data?.altura}></FormBox.Cell>
        </FormBox.Row>
    </FormBox.Container>

    <FormBox.Container title="Items">
        <FormBox.Row>
            <Datatable {schema} data={dataItems} ordering />
        </FormBox.Row>
    </FormBox.Container>

    {#if photos.length > 0}
        <span style="margin:0">
            <Typography style="margin-bottom: -5px 0 15px 0">Fotos</Typography>
            <Gallery {photos} />
        </span>
    {/if}

    <FormBox.Container title="Ubicación">
        <FormBox.Row>
            <span style="height: 450px; width:100%">
                <LocationPicker
                    {...ubic}
                    searchBar={false}
                    automark={false}
                    zoom={0}
                    disabled
                />
            </span>
        </FormBox.Row>
    </FormBox.Container>
    <BackDrop {visible} style="position: fixed;">
        <LicitacionWidget
            title="Ofertar"
            on:close={() => (visible = false)}
            items={$dataItems}
            dataSource={{
                ...data,
                cuit_ii: JSON.parse(localStorage.getItem('ProviderData')).data
                    .cuit_ii,
            }}
        />
    </BackDrop>
    <Button
        disabled={!ofertable}
        label="Ofertar"
        on:click={() => (visible = true)}
    />
</Content>
